import * as React from "react";
import Button from "@material-ui/core/Button";
import Dashboard from "../dashboard/Dashboard";

/**
 * Container component for the home page.
 * 
 */
export default class Home extends React.Component {

    render() {
        return (
            <Dashboard />
        );
    }

}
